/**
 * Component: M61 Learn Cloud Cards
 * 
 */
'use strict';

import { LearnCloudFilterHelper } from '../filter-helper-learn-cloud.js';

export class LearnCloudCards {
    constructor() {
        this.selectors = {
            component: $('.c-v4-m61-learn-cloud-cards'),
            main: $('.c-v4-m61-learn-cloud-cards--main'),
        };

        this.helper = new LearnCloudFilterHelper;
    }

    /**
     * Init
     * 
     */
    init() {
        if (!this.selectors.component.length) return;

        this.helper.init_config({
            action: 'sysdig_v4_filter__learn_cloud_cards',
            add_chip_on_active: false,
            chips_taxonomy: 'learning-center-topic',
            component_id: this.selectors.component.attr('id'),
            items_per_page: 12,
            items_per_row: this.selectors.main.attr('data-per-row') || 3,
            paged: 1,
            post_types: [],
            remove_chip_on_deactivate: false,
            search_term: this.selectors.main.attr('data-search') || '',
            terms: JSON.parse(this.selectors.main.attr('data-terms')) || {},
            url: this.selectors.main.attr('data-url'),
            view_toggle: 'grid',
        });

        this.helper.init_target({
            target_container: this.selectors.main,
            top: this.selectors.main,
        });

        this.helper.init();
    }
}
